import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router';

import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { ROUTES } from '@constants/routes';
import { logNetRequest, scrollToTop } from '@utils/usefulFuncs';
import ChatQueryTool from '@features/chat/ChatQueryTool';
import { Body5, Container, H5, Page } from '@ui';
import { AI_TOOLS, DOC_SELECT_MODES } from '@constants';
import { handle400Statuses, sendApiRequest } from '@services/api';
import { Working } from '@ui/Working';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const tool = AI_TOOLS.RFP_CHAT_QUERY;

function RFPChatDigitalAnalyst() {
  const navigate = useNavigate();

  const [isReady, setIsReady] = React.useState(false);
  const [pageError, setPageError] = React.useState(null);
  const [docSelectModes] = React.useState([
    DOC_SELECT_MODES.customMode,
    DOC_SELECT_MODES.companyTag,
    DOC_SELECT_MODES.myDocs,
  ]);
  const [defaultActiveDocSelectMode] = React.useState(DOC_SELECT_MODES.customMode);
  const [defaultSelectedDocs, setDefaultSelectedDocs] = React.useState([]);

  const onGoBack = () => navigate(ROUTES.home);

  const onPageError = (error) => {
    setPageError(error);
  };

  React.useEffect(() => {
    scrollToTop();

    const getDefaultSelectedDocs = async () => {
      const URL = 'v1/genai/documents/default?user_mode=' + tool;
      const { status, data } = await sendApiRequest('get', URL);
      handle400Statuses(status);
      logNetRequest(URL, status, data);
      if (status === 200) {
        setDefaultSelectedDocs(data.documents);
        setIsReady(true);
      } else {
        setPageError('Something went wrong, refresh the page and try again.');
      }
    };
    getDefaultSelectedDocs();
  }, []);

  if (pageError) {
    return (
      <PageWrapper>
        <Header />
        <Body withFooter>
          <Page width={'1000px'}>
            <H5>Digital Analyst Chat</H5>
            <Container top={24} bottom={400}>
              <Body5>Something went wrong, refresh the page and try again.</Body5>
            </Container>
          </Page>
        </Body>
      </PageWrapper>
    );
  }

  if (!isReady) {
    return (
      <PageWrapper>
        <Header />
        <Body withFooter>
          <Page width={'1000px'}>
            <H5>Digital Analyst Chat</H5>
            <Container top={24} bottom={400}>
              <Working message="Loading source documents..." />
            </Container>
          </Page>
        </Body>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <ChatQueryTool
          onGoBack={onGoBack}
          tool={tool}
          onPageError={onPageError}
          docSelectModes={docSelectModes}
          defaultActiveDocSelectMode={defaultActiveDocSelectMode}
          preSelectedDocs={defaultSelectedDocs}
          disableAgent
        />
      </Body>
    </PageWrapper>
  );
}

export default RFPChatDigitalAnalyst;
